import React, { useState } from 'react';
import { Pencil, Check, X, Loader2 } from 'lucide-react';

// Click-to-edit text/number cell. onSave(value) should return a promise.
export const InlineEdit = ({ value, display, onSave, type = 'text', testId, className = '' }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const start = () => { setDraft(value ?? ''); setEditing(true); };
  const save = async () => {
    if (String(draft).trim() === String(value ?? '')) { setEditing(false); return; }
    setBusy(true);
    try { await onSave(type === 'number' ? Number(draft) : String(draft).trim()); setEditing(false); } catch { /* caller toasts */ }
    finally { setBusy(false); }
  };
  if (!editing) {
    return (
      <button type="button" onClick={start} className={`group inline-flex items-center gap-1.5 text-left hover:text-[#20acf6] transition-colors ${className}`} data-testid={`${testId}-display`} title="Click to edit">
        <span className="truncate">{display ?? value}</span>
        <Pencil className="h-3 w-3 shrink-0 opacity-0 group-hover:opacity-60 transition-opacity" />
      </button>
    );
  }
  return (
    <span className="inline-flex items-center gap-1">
      <input autoFocus type={type} step={type === 'number' ? '0.01' : undefined} min={type === 'number' ? 0 : undefined} value={draft}
        onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setEditing(false); }}
        className={`h-8 px-2 rounded-md border border-[#20acf6] text-sm outline-none focus:ring-2 focus:ring-[#20acf6]/30 ${type === 'number' ? 'w-24' : 'w-56'}`} data-testid={`${testId}-input`} />
      <button type="button" onClick={save} disabled={busy} className="p-1 rounded text-green-600 hover:bg-green-50" data-testid={`${testId}-save`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}
      </button>
      <button type="button" onClick={() => setEditing(false)} className="p-1 rounded text-slate-400 hover:bg-slate-100" data-testid={`${testId}-cancel`}><X className="h-4 w-4" /></button>
    </span>
  );
};
